import { setContext } from "@apollo/client/link/context";

import { StorageKey } from "@ctypes";
import { getCookie } from "@utils";

export const authLink = setContext((_, context) => {
  const token = localStorage.getItem(StorageKey.Token);
  const fbp = getCookie("_fbp");
  const fbc = getCookie("_fbc");

  return {
    headers: {
      ...context.headers,
      Authorization: token ? `Bearer ${token}` : "",
      "x-fm-device-platform": "web",
      "x-fm-device-timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      "x-fm-anonymous-id": localStorage.getItem(StorageKey.AnonymousId),
      // Meta Pixel's own browser/click-id cookies, set once the Pixel script loads.
      // Forwarded so the backend can persist them for later server-side Conversions API calls.
      // Left off when the cookie is missing: an undefined header value goes out as the string "undefined".
      ...(fbp && { "x-fm-fbp": fbp }),
      ...(fbc && { "x-fm-fbc": fbc }),
    },
  };
});
